import { SPIRE_IFRAME_ID } from './spire.constants';

export type SpireComponentProps = {
  iframeUrl: string;
  onLoad?: () => void;
};

export const SpireComponent = ({ iframeUrl, onLoad }: SpireComponentProps) => {
  return (
    <iframe
      id={SPIRE_IFRAME_ID}
      src={iframeUrl}
      title="Spire Enrollment"
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        display: 'block',
        position: 'absolute',
        top: 0,
        left: 0,
      }}
      onLoad={onLoad}
    />
  );
};
